window.themeLoadPlugin = function (js, css, callback, placement) {
  jQuery.ajaxPrefilter("script", function (s) {
    s.crossDomain = true;
  });
  if (js) {
    let progress         = 0;
    let internalCallback = function () {
      // Complete
      if (++progress === js.length) {
        $.each(css, function (index, value) {
          $('head').prepend('<link href="' + value + '" rel="stylesheet" type="text/css" />');
        });

        if (callback && typeof(callback) === "function") {
          callback();
        }
      }
    };

    if (placement === undefined) {
      $.each(js, function (index, value) {
        $.getScript(value, internalCallback);
      });
    }
    else if (placement === 'append') {
      $.each(js, function (index, value) {
        $('script[src*="IWT.min.js"]').after('<script src="' + value + '"></script>');
        internalCallback();
      });
    }
  }
};

window.loadScript = function (src, callback) {
  let script  = document.createElement("script");
  script.type = "text/javascript";
  if (callback) script.onload = callback;
  document.getElementsByTagName("head")[0].appendChild(script);
  script.src = src;
};

window.loadCSS = function (src) {
  $('head').prepend('<link href="' + src + '" rel="stylesheet" type="text/css" />');
};



// WEBPACK FOOTER //
// ./src/themes/pac/js/theme.js